const addressTypesMap = {
  billing: 'billing',
  shipping: 'shipping',
}
export default addressTypesMap
